import {Component} from "preact";
import Toolbar from "../../../../../layout/toolbar";
import {translate} from "../../../../../../services/TranslateService";
import ToolbarButton from "../../../../../common/toolbar-button";
import PlusIcon from 'mdi-preact/PlusIcon';
import ToolbarTitle from "../../../../../layout/toolbar-title";
import SectionComponent from "../../../../../layout/section-component";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import Text from "../../../../../common/text";
import ChatInfiniteScrollList from "../chat-infinite-scroll-list";
import ChatIcon from 'mdi-preact/ChatIcon';
import style from './styles.scss';
import ChatOutlineIcon from "mdi-preact/ChatOutlineIcon";
import Permission from "../../../../../common/permission/permission";

export default class ChatList extends Component {
    static defaultProps = {
        onNavigate: () => {}
    };

    render(props, state, context) {
        return (
            <VerticalUiContainer>
                <Toolbar class={style.toolbar}>
                    <SectionComponent style={{flexGrow: 2}}>
                        <div class={style.iconButton}><ChatOutlineIcon/></div>
                        <ToolbarTitle><Text text={'chat.title'}/></ToolbarTitle>
                    </SectionComponent>
                    <SectionComponent style={{flexShrink: 0}}>
                        <Permission permissions={['chat.create']}>
                            <ToolbarButton onClick={this.newChat} title={translate('chat.new.title')}><PlusIcon/></ToolbarButton>
                        </Permission>
                    </SectionComponent>
                </Toolbar>
                <ChatInfiniteScrollList onChatClick={this.getChat}/>
            </VerticalUiContainer>
        );
    }

    getChat = (chat) => {
        this.props.onNavigate('read', {chat: chat});
    };

    newChat = () => {
        return this.props.onNavigate('create');
    };
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/chat-list/index.js